// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__Fy8cm","list":"PatternAutocomplete_list__hFUuY"};